import { render, staticRenderFns } from "./Shoppinglist.vue?vue&type=template&id=7e54c9fc&"
import script from "./Shoppinglist.vue?vue&type=script&lang=js&"
export * from "./Shoppinglist.vue?vue&type=script&lang=js&"
import style0 from "./Shoppinglist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports